import { API_URLS } from '@helpers/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const retrievePinboards = createAsyncThunk('pinboards/retrieve', async () => {
    const response = await fetch(API_URLS.retrievePinboards);
    return (await response.json());
});
